/**
 * Assigns allowed keys from the source object to the target object.
 * Ignores any keys not included in the allowed list.
 *
 * @template T - The shape of the target object.
 * @template K - A subset of the keys of T.
 *
 * @param target - The target object to mutate.
 * @param source - The object with values to assign from.
 * @param keys - An array of keys to copy from source to target.
 */
export const assignAllowedKeys = <T extends object, K extends keyof T>(
  target: T,
  source: Partial<T>,
  keys: K[],
): void => {
  if (__DEV__) {
    const unknownKeys = Object.keys(source).filter(
      (key) => !keys.includes(key as K),
    );
    if (unknownKeys.length > 0) {
      console.warn('[assignAllowedKeys] Ignored unknown keys:', unknownKeys);
    }
  }
  for (const key of keys) {
    if (key in source) {
      target[key] = source[key]!;
    }
  }
};
